<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
      <div>
        <v-btn
          v-if="depositsPermissions['export-deposits-report']"
          dark
          depressed
          rounded
          @click="openDownloadDeposits({ deposits: true })"
          color="secondary">
          <v-icon color="white">mdi-application-export</v-icon>
          Exportar depósitos a CSV
        </v-btn>
      </div>
      <div class="ml-2">
        <v-btn
          v-if="depositsPermissions['export-deposits-report']"
          dark
          depressed
          rounded
          @click="openDownloadDeposits()"
          color="primary">
          <v-icon color="white">mdi-application-export</v-icon>
          Exportar facturación a CSV
        </v-btn>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [300, 400, 500]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1">
        <template v-slot:top>
          <div class="d-flex align-center pa-3">
            <div class="mr-3">
              Filtros:
            </div>
            <div class="mr-3">
              <v-menu
                ref="datePicker"
                v-model="datePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="range"
                    label="Rango de fechas"
                    prepend-icon="mdi-calendar"
                    readonly
                    hide-details
                    dense
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="month"
                  first-day-of-week="1"
                  type="month"
                  color="primary"
                  no-title
                  :allowed-dates="allowedDates"
                >
                  <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                  <v-spacer/>
                  <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                  <v-btn :disabled="dates.length < 2" color="primary" @click="filter">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div>
              <v-select
                v-model="statusSelected"
                :items="statuses"
                item-value="value"
                item-text="text"
                label="Estatus"
                hide-details
                return-object
                dense
                @change="filter"
              />
            </div>
          </div>
        </template>
        <template v-slot:item._id="{ item }">
          <a href="" @click.prevent="openDetail(item._id)">
            {{ item._id }}
          </a>
        </template>
        <template v-slot:item.updatedAt = "{ item }">
          {{ item.updatedAt | toDate }}
        </template>
        <template v-slot:item.status = "{ item }">
          {{ statuses.find(status => status.value === item.status).text }}
        </template>
        <template v-slot:item.amount="{ item }">
          <div class="mb-2">
            {{ item.amount | toFixNumber(2) | numberWithComma | prefix('$') }}
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <DetailDeposit ref="detailPanel" :deposit="selectDeposit" />

    <DownloadDeposits ref="downloadDeposits" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import DetailDeposit from '@/components/sidePanels/DepositDetail'
import DownloadDeposits from '@/components/modals/DownloadDeposits'

export default {
  name: 'ProviderDeposits',
  components: {
    DetailDeposit,
    DownloadDeposits
  },
  data () {
    return {
      overlay: false,
      datePicker: false,
      month: new Date().toISOString(),
      section: this.$i18n.t('deposits.section'),
      table: {
        title: this.$i18n.t('deposits.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('deposits.headers.date'), value: 'createdAt', sortable: false },
          { text: this.$i18n.t('deposits.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('deposits.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('deposits.headers.amount'), value: 'amount', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 300,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      selectDeposit: '',
      file: '',
      statuses: [
        { value: '', text: 'Todos' },
        { value: 'in-transit', text: 'Pendiente', color: 'grey' },
        { value: 'settled', text: 'Pagado', color: 'primary' }
      ],
      statusSelected: { value: '', text: 'Todos' }
    }
  },
  computed: {
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    provider () {
      return this.$store.state.currentProvider.data._id
    },
    disabledExport () {
      return !this.dates.length || !this.statusSelected.value
    },
    depositsPermissions () {
      return this.$store.state.login.permissions['my-deposits'].components['deposits-list'].actions
    },
    dates () {
      const dates = []
      if (this.$moment(this.month).isValid()) {
        const start = this.$moment(this.month).startOf('month').format('YYYY-MM-DD')
        const end = this.$moment(this.month).endOf('month').format('YYYY-MM-DD')
        dates.push(start, end)
      }
      return dates
    },
    exportRoute () {
      const dates = [...this.dates]
      dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      let url = process.env.VUE_APP_API_URL
      url += `/v1/providers/${this.$store.state.currentProvider.data._id}/download?access_token=${this.$store.state.login.token}`
      url += `&provider=${this.$store.state.currentProvider.data._id}`
      url += `&startDate>=${dates[0] || ''}&endDate<=${dates[1] || ''}`
      return url
    }
  },
  methods: {
    openDetail (id) {
      this.selectDeposit = id
      this.$refs.detailPanel.open()
    },
    openDownloadDeposits (options) {
      this.$refs.downloadDeposits.open(options)
    },
    async resetDate () {
      this.month = new Date().toISOString()
      await this.load()
      this.datePicker = false
    },
    async updateTable (data) {
      this.table.options = data
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        provider: this.provider,
        status: this.statusSelected.value
      }
      try {
        await this.load(params)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async filter () {
      let dates = {}
      if (this.dates.length) {
        this.dates.sort((a, b) => {
          if (a < b) return -1
          if (a > b) return 1
          return 0
        })
        dates['updatedAt>'] = this.dates[0]
        dates['updatedAt<'] = this.dates[1]
      }

      const params = {
        ...dates,
        status: this.statusSelected.value,
        limit: this.table.options.itemsPerPage,
        provider: this.provider,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      await this.load(params)
      this.datePicker = false
    },
    async load (params) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        provider: this.provider,
        status: this.statusSelected.value
      }
      if (this.dates.length) {
        params['updatedAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        params['updatedAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/deposits`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    }
  }
}
</script>
